import React, { useState } from 'react';
import IsOwner from './IsOwner';
import PercentOwnership from './PercentOwnership';

export default function Ownership({
  askIsOwner,
  askPercentOwnershipOnLoad,
  onIsOwnerChange,
  onPercentOwnershipChange,
}: {
  askIsOwner: boolean;
  askPercentOwnershipOnLoad: boolean;
  onIsOwnerChange?: (isOwner: boolean) => void;
  onPercentOwnershipChange: (percentOwnership: number) => void;
}): JSX.Element {
  const [isOwner, setIsOwner] = useState(false);

  return (
    <div className='md:flex mb-5'>
      {askIsOwner && (
        <IsOwner
          onChange={(isOwner): void => {
            setIsOwner(isOwner);
            if (onIsOwnerChange !== undefined) {
              onIsOwnerChange(isOwner);
            }
          }}
        />
      )}
      {((askIsOwner && isOwner) || askPercentOwnershipOnLoad) && (
        <PercentOwnership onChange={onPercentOwnershipChange} />
      )}
    </div>
  );
}
